<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <!-- SELECIONAR TIPO CADASTRO-->
  <div class="row" v-if="!formData.cadastro_tipo">
    <div class="col-12 col-sm-12 col-md-4">
      <div class="card card-outline card-primary" @click="formData.cadastro_tipo = 'pf'">
        <div class="card-header text-center">
          <a class="h1"><b>CPF</b></a>
        </div>
        <div class="card-body" style="text-align: center">
          <i class="fa fa-regular fa-user" style="font-size: 50px"></i>

          <br />
          <br />
          <p syle="font-size:17px">Cadastro de pessoa física</p>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-4">
      <div class="card card-outline card-primary" @click="formData.cadastro_tipo = 'pj'">
        <div class="card-header text-center">
          <a class="h1"><b>CNPJ</b></a>
        </div>
        <div class="card-body" style="text-align: center">
          <i class="fa fa-regular fa-building" style="font-size: 50px"></i>
          <br />
          <br />
          <p syle="font-size:17px">Cadastro de pessoa jurídica</p>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-4">
      <div class="card card-outline card-primary" @click="confirmarMagistrado">
        <div class="card-header text-center">
          <a class="h1"><b>Magistrado</b></a>
        </div>
        <div class="card-body" style="text-align: center">
          <i class="fa-solid fa-gavel" style="font-size: 50px"></i>
          <br />
          <br />
          <p syle="font-size:17px">Cadastro de magistrado</p>
        </div>
      </div>
    </div>
  </div>

  <!-- DADOS PF -->
  <div class="row" v-if="formData.cadastro_tipo === 'pf'">
    <completar-cadastro-pf :magistrado="magistrado" :orgaos_expedidores_rg="orgaos_expedidores_rg" :paises="paises" />
  </div>

  <!-- DADOS PF -->
  <div class="row" v-if="formData.cadastro_tipo === 'pj'">
    <completar-cadastro-pj :orgaos_expedidores_rg="orgaos_expedidores_rg" :paises="paises" />
  </div>
</template>

<script>
import sweetAlert from "../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Loading from "vue-loading-overlay";

import useVueLidate from "@vuelidate/core";
import { email, sameAs, helpers } from "@vuelidate/validators";
import { required } from "../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["orgaos_expedidores_rg", "paises"],

  components: { Loading },

  setup() {
    const formData = reactive({
      cadastro_tipo: "",
      nome_completo: "",
      cpf: "",
      rg: "",
      orgao_expedidor: "",
      data_emissao_rg: "",
      naturalidade: "",
      nacionalidade: "",
      data_nascimento: "",
      sexo: "",
      estado_civil: "",
      endereco_cep: "",
      endereco_num: "",
      endereco_complemento: "",
      endereco_bairro: "",
      endereco: "",
      endereco_estado: "",
      endereco_estado_id: "",
      endereco_cidade: "",
      endereco_cidade_id: "",
      endereco_complemento: "",
    });

    const rules = computed(() => {
      return {
        cadastro_tipo: { required },
        nome_completo: { required },
        orgao_expedidor: { required },
        cpf: { required, validarCPF: helpers.withMessage(" Digite um CPF válido.", validarCPF) },
        rg: { required },
        data_emissao_rg: {
          required,
          minValue: helpers.withMessage(" Digite uma data válida.", minDate),
        },
        naturalidade: { required },
        nacionalidade: { required },
        data_nascimento: {
          required,
          minValue: helpers.withMessage(" Digite uma data válida.", minBirthDate),
        },
        sexo: { required },
        estado_civil: { required },
        endereco_cep: { required },
        endereco_cidade: { required },
        endereco_estado: { required },
        endereco: { required },
        endereco_bairro: { required },
        endereco_num: { required },
        endereco_complemento: { required },
      };
    });

    const minDate = (date) => {
      return new Date(date) >= new Date("01-01-1990");
    };

    const minBirthDate = (date) => {
      return new Date(date) >= new Date("01-01-1940");
    };

    const validarCPF = (cpf) => {
      cpf = cpf.replace(/\D/g, "");
      if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
      var result = true;
      [9, 10].forEach(function (j) {
        var soma = 0,
          r;
        cpf
          .split(/(?=)/)
          .splice(0, j)
          .forEach(function (e, i) {
            soma += parseInt(e) * (j + 2 - (i + 1));
          });
        r = soma % 11;
        r = r < 2 ? 0 : 11 - r;
        if (r != cpf.substring(j, j + 1)) result = false;
      });
      return result;
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  data() {
    return {
      isLoading: false,
      termos: false,
      cep_valido: false,
      campos_endereco_bloqueados: true,
      magistrado: false,
    };
  },

  mounted() {
    console.log(this.orgaos_emissores);
  },

  methods: {
    confirmarMagistrado() {
      this.$swal
        .fire({
          title: "Confirmação",
          text:
            "Essa opção deve ser selecionada para o cadastro de magistrado. Toda a documentação comprobatória será solicitada para confirmação do cadastro.",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#4caf50",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.value) {
            this.magistrado = true;
            this.formData.cadastro_tipo = "pf";
          }
        });
    },

    buscarCep() {
      this.isLoading = true;
      this.cep_valido = false;

      let data = {
        cep: this.formData.endereco_cep,
      };

      axios
        .post(process.env.MIX_VUE_APP_VALIDAR_CEP + `/search`, data)
        .then((response) => {
          this.isLoading = false;

          console.log(response.data);

          if (response.data.status == "OK" && !response.data.dados.erro) {
            let dados = response.data.dados;

            console.log(dados);

            this.buscarCidade(dados);

            this.formData.endereco = dados.logradouro;
            this.formData.endereco_bairro = dados.bairro;
            this.formData.endereco_cidade = dados.localidade;

            this.cep_valido = true;
          } else {
            let mensagem = response.data.mensagem;

            if (!response.data.mensagem) {
              mensagem = "Digite um cep válido!";
            }

            this.showErrorMessageWithButton("Ops...", mensagem);
            this.cep_valido = false;
          }
        })
        .catch((error) => {
          this.isLoading = false;

          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    buscarCidade(dados) {
      console.log("Buscando cidade");

      let data = {
        nome: dados.localidade,
        estado_sigla: dados.uf,
      };

      console.log(data);

      axios
        .post(`/user/cidade/buscar`, data)
        .then((response) => {
          if (response.data.success) {
            this.formData.endereco_cidade = response.data.cidade.nome;
            this.formData.endereco_cidade_id = response.data.cidade.id;

            this.formData.endereco_estado = response.data.estado.nome;
            this.formData.endereco_estado_id = response.data.estado.id;
          } else {
            this.formData.cidade = response.data.cidade = "";
            this.formData.estado = response.data.estado = "";

            this.formData.endereco_estado = "";
            this.formData.endereco_estado_id = "";
          }

          console.log(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    async enviar() {
      const result = await this.v$.$validate();

      if (result) {
        if (this.cep_valido) {
          this.create();
        } else {
          this.showErrorMessageWithButton("Ops...", "Digite um cep válido!");
          this.cep_valido = false;
        }
      }
    },

    async create() {
      this.isLoading = true;

      let data = {
        cadastro_tipo: this.formData.cadastro_tipo,
        nome: this.formData.nome_completo,
        cpf: this.formData.cpf,
        rg: this.formData.rg,
        orgao_expedidor_id: this.formData.orgao_expedidor.id,
        data_emissao_rg: this.formData.data_emissao_rg,
        naturalidade: this.formData.naturalidade,
        nacionalidade: this.formData.nacionalidade,
        sexo: this.formData.sexo,
        estado_civil: this.formData.estado_civil,
        endereco_cep: this.formData.endereco_cep,
        endereco_num: this.formData.endereco_num,
        endereco_complemento: this.formData.endereco_complemento,
        endereco: this.formData.endereco,
        endereco_bairro: this.formData.endereco_bairro,
        estado_id: this.formData.endereco_estado_id,
        cidade_id: this.formData.endereco_cidade_id,
        data_nascimento: this.formData.data_nascimento,
        data_emissao_rg: this.formData.data_emissao_rg,
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/user/profile/complete`, data)
        .then((response) => {
          this.showSuccessMessage("Cadastro enviado!");

          window.location.href = "/login";
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", "Email já cadastrado!");
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.card-outline:hover {
  background-color: #428bca;
  cursor: pointer;
}

.inner {
  background-color: white;
}

label,
h3,
input {
  color: black;
}
</style>
